import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

new Swiper('.location-carousel', {
    slidesPerView: "auto",
    spaceBetween: 16,
    loop: false,
    speed: 1000,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
    navigation: {
        prevEl: '.location-carousel-prev',
        nextEl: '.location-carousel-next',
    },
});

new Swiper('.image-carousel', {
    slidesPerView: 1.25,
    spaceBetween: 16,
    loop: true,
    centeredSlides: true,
    speed: 1000,
    breakpoints: {
        768: {
            slidesPerView: 1.5,
        },
        1280: {
            slidesPerView: 'auto',
        },
    },
    navigation: {
        prevEl: '.image-carousel-prev',
        nextEl: '.image-carousel-next',
    },
});

new Swiper('.articles-carousel', {
    slidesPerView: 1.125,
    spaceBetween: 16,
    speed: 1000,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
    breakpoints: {
        768: {
            slidesPerView: 1.5,
        },
        1024: {
            slidesPerView: "auto",
        },
    },
    navigation: {
        prevEl: '.article-prev',
        nextEl: '.article-next',
    },
});
